import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-col",
  style: {"gap":"20px"}
}
const _hoisted_2 = { class: "flex flex-row gap-4" }
const _hoisted_3 = { class: "mt-2 w-full inline-block relative" }
const _hoisted_4 = { class: "absolute right-0 bottom-0 mr-2 mb-2 text-gray-lp-600 text-12px xxl:text-14px" }
const _hoisted_5 = {
  key: 0,
  class: "pt-3 text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2"
}
const _hoisted_6 = { class: "text-gray-lp-500 mt-2 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Title, {
      class: "mb-4",
      label: _ctx.$t('clientManagement.registrationForm.billing.title'),
      fontSize: 20
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('clientManagement.managementDetail.whatsappNumber'),
          asterisk: "",
          style: {"flex":"1"},
          fontSize: 14
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpInput, {
              prefix: _ctx.prefix,
              placeholder: "Contoh: 8123456789012",
              modelValue: _ctx.formModel.noWhatsApp,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formModel.noWhatsApp = $event)),
              errorCaption: "Masukan No. WhatsApp dengan benar",
              error: _ctx.formErrorModel.contactWhatsApp,
              format: _ctx.formatNumber,
              onChange: _ctx.validatePhone
            }, null, 8, ["prefix", "modelValue", "error", "format", "onChange"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('clientManagement.managementDetail.billingSchedule'),
          asterisk: "",
          style: {"flex":"1"},
          fontSize: 14
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CustomDropdown, {
              class: "mt-2",
              placeholder: _ctx.$t('clientManagement.registrationForm.billing.selectBillingSchedule'),
              customValueStyle: "text-sm",
              customOptionStyle: "text-sm",
              options: _ctx.billingScheduleList,
              selectedItem: _ctx.formModel.billingSchedule,
              modelValue: _ctx.formModel.billingSchedule,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formModel.billingSchedule = $event))
            }, null, 8, ["placeholder", "options", "selectedItem", "modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('clientManagement.managementDetail.paymentTerm'),
          asterisk: "",
          style: {"flex":"1"},
          fontSize: 14
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CustomDropdown, {
              class: "mt-2",
              placeholder: _ctx.$t('clientManagement.registrationForm.billing.selectPaymentTerm'),
              customValueStyle: "text-sm",
              customOptionStyle: "text-sm",
              options: _ctx.rangeTimePaymentList,
              selectedItem: _ctx.formModel.timeRangePayment,
              modelValue: _ctx.formModel.timeRangePayment,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formModel.timeRangePayment = $event))
            }, null, 8, ["placeholder", "options", "selectedItem", "modelValue"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('clientManagement.managementDetail.email'),
        asterisk: "",
        fontSize: 16
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Multiselect, {
              "tag-placeholder": _ctx.$t('clientManagement.registrationForm.billing.pressEnterToAddEmail'),
              placeholder: _ctx.$t('clientManagement.registrationForm.billing.enterEmail'),
              isTextArea: "",
              "open-direction": "below",
              customNoResult: _ctx.$t('clientManagement.registrationForm.billing.emailAlreadyAdded'),
              showNoOptions: false,
              options: _ctx.emailOptions,
              multiple: true,
              taggable: true,
              maxLength: 20,
              isError: _ctx.errorEmail,
              modelValue: _ctx.formModel.email,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formModel.email = $event))
            }, null, 8, ["tag-placeholder", "placeholder", "customNoResult", "options", "isError", "modelValue"]),
            _createVNode("div", _hoisted_4, _toDisplayString(_ctx.formModel.email?.length) + "/20 ", 1)
          ]),
          (_ctx.formErrorModel.emailBilling)
            ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("clientManagement.registrationForm.contact.invalidEmail")), 1))
            : _createCommentVNode("", true),
          _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("clientManagement.registrationForm.billing.multipleEmailHint")), 1)
        ]),
        _: 1
      }, 8, ["label"])
    ])
  ]))
}